import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { GlobalStateService } from '../global/global-state.service';
import { NegotiationFilters } from 'src/app/shared/models';

@Injectable({
  providedIn: 'root'
})
export class NegotiationsService {

  private service_type = "negotiations"
  public baseURL = '';

  constructor(private _globalStateService: GlobalStateService, private _http: HttpClient) {
    this.baseURL = this._globalStateService.GetBaseEndpoint('base');
  }

  GetData(page_number: string, search: string = '', filters?: NegotiationFilters): Observable<any> {
    let params = new HttpParams()
      .set('page', page_number)
      .set('per_page', '20');

    if (search) {
      params = params.set('search', search);
    }

    // Add filter parameters if provided
    if (filters) {
      Object.keys(filters).forEach(key => {
        const value = filters[key as keyof NegotiationFilters];
        if (value !== undefined && value !== null && value !== '') {
          params = params.set(key, value.toString());
        }
      });
    }

    const url = `${this.baseURL}/${this.service_type}`;
    return this._http.get<any>(url, { params });
  }

  // Get filter dropdown data
  GetFilterData(): Observable<any> {
    const url = `${this.baseURL}/${this.service_type}/filters`;
    return this._http.get<any>(url);
  }

  GetDataById(id: any): Observable<any> {
    const url = `${this.baseURL}/${this.service_type}/${id}`; // Replace with your API endpoint
    return this._http.get<any>(url);
  }

  DeleteDataById(id: any): Observable<any> {
    const url = `${this.baseURL}/${this.service_type}/${id}`; // Replace with your API endpoint
    return this._http.delete<any>(url);
  }

  AddData(data: any): Observable<any> {
    const url = `${this.baseURL}/${this.service_type}`; // Replace with your API endpoint
    return this._http.post<any>(url, data);
  }

  UpdateData(id: string, data: any): Observable<any> {
    const url = `${this.baseURL}/${this.service_type}/${id}`; // Replace with your API endpoint
    return this._http.patch<any>(url, data);
  }

}
